import { InlineButton } from './InlineButton';
import { InlineInput } from './InlineInput';
export default {
    Input: InlineInput,
    Button: InlineButton
};
